import PrivateMediaBadge from '../../../shared/ui/PrivateMediaBadge';

// 02.3-client.md paso b -- extraído de `renderUploadBtn` en SubPanelTratos.jsx (14 call sites).
// Presentacional: sin `clientApi`/hooks/toast -- toda la data y los `on*` vienen por props.
// Estilos inline preservados verbatim (conversión a tokens es el paso `e`).
export default function DocUploadCard({ label, doc, isUploading, progress, isReadOnly, onOpenPicker, onFileChange, onToggleVisibility, onPreview, inputId }) {
    return (
        <div style={{ marginBottom: 'var(--space-4)' }}>
            <div
                className={`op-upload-card ${doc ? 'uploaded' : ''}`}
                onClick={() => { if (!isReadOnly && !doc) onOpenPicker(); }}
                style={{ opacity: isReadOnly && !doc ? 0.5 : 1, cursor: isReadOnly && !doc ? 'not-allowed' : 'pointer', marginBottom: 0 }}
            >
                <div className="op-upload-icon-box">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>
                </div>
                <div className="op-upload-info">
                    {isUploading ? (
                        <>
                            <div className="op-upload-name">Subiendo... {progress}%</div>
                            <div style={{ height: '3px', width: '100%', background: '#333', marginTop: 'var(--space-1)', borderRadius: '2px' }}>
                                <div style={{ height: '100%', background: '#10b981', width: progress + '%', transition: 'width 0.2s', borderRadius: '2px' }} />
                            </div>
                        </>
                    ) : doc ? (
                        <>
                            <div className="op-upload-name">{doc.name || label}</div>
                            <div className="op-upload-sub">Subido correctamente</div>
                        </>
                    ) : (
                        <>
                            <div className="op-upload-name">{label}</div>
                            <div className="op-upload-sub">Haz clic para subir archivo</div>
                        </>
                    )}
                </div>
                {doc && (
                    <PrivateMediaBadge
                        className="inline"
                        access={doc.access || 'private'}
                        onToggle={doc.path ? onToggleVisibility : undefined}
                    >
                        <div className="op-upload-eye" onClick={(e) => { e.stopPropagation(); onPreview(); }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                        </div>
                    </PrivateMediaBadge>
                )}
                <input type="file" id={inputId} style={{ display: 'none' }} onChange={onFileChange} />
            </div>
        </div>
    );
}
